module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/~/json-loader!./.cache/json/layouts-gallery.json
// module id = 1061
// module chunks = 21693109666204